// extracted by mini-css-extract-plugin
export var clickableHeaderContent = "_ey-0";
export var headerCellHover = "_ey-1";